import * as styles from "./IntroRehoming.module.scss";

import React, { lazy } from "react";
import SSRSuspense from "../../../components/SSRSuspense/SSRSuspense";
import CurvedBorder from "../../../components/borders/CurvedBorder";
import ProcessedImage from "../../../components/common/ProcessedImage/ProcessedImage";
import type { InlineFiltersProps } from "../../../containers/filters/InlineFilters/ie/InlineFilters";
import { Colours } from "../../../utils/colours";

const InlineFilters: React.FC<InlineFiltersProps> =
	process.env.GATSBY_IS_IE === "true"
		? lazy(
				() =>
					import("../../../containers/filters/InlineFilters/ie/InlineFilters"),
			)
		: lazy(
				() =>
					import("../../../containers/filters/InlineFilters/uk/InlineFilters"),
			);
export interface SectionSpotlightDogsProps {
	title: string;
	body: string;
	imgSrc: string;
	imgAlt: string;
}

export const IntroRehoming: React.FC<SectionSpotlightDogsProps> = ({
	title,
	body,
	imgSrc,
	imgAlt,
}) => {
	return (
		<div className={styles.introcolumnouter}>
			<div className={styles.introcolumninner}>
				<div className={styles.twocolumncontent}>
					<div className={styles.leftcolumn}>
						<div className={styles.text}>
							<h1>{title}</h1>
							{body && (
								<div
									// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
									dangerouslySetInnerHTML={{
										__html: body,
									}}
								/>
							)}
						</div>
						<div className={styles.dogimage}>
							<ProcessedImage
								src={imgSrc}
								alt={imgAlt}
								dimensions="400x300"
								width={400}
								height={300}
								loading="eager"
							/>
						</div>
					</div>
					<div className={styles.rightcolumn}>
						<InlineFilters />
					</div>
				</div>
				<div className={styles.columnscurvedborderwrapper}>
					<CurvedBorder
						className={styles.columnscurvedborder}
						fill={Colours.SANDY_FUR}
						rotation={0}
					/>
				</div>
			</div>
			<div className={styles.tworowcontent}>
				<div className={styles.toprow}>
					<div className={styles.text}>
						<h1>{title}</h1>
						{body && (
							<div
								// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
								dangerouslySetInnerHTML={{
									__html: body,
								}}
							/>
						)}
					</div>
					<div className={styles.rowscurvedborderwrapper}>
						<CurvedBorder
							className={styles.rowscurvedborder}
							fill={Colours.SANDY_FUR}
							rotation={0}
						/>
					</div>
					<div className={styles.dogimage}>
						<ProcessedImage
							src={imgSrc}
							alt={imgAlt}
							dimensions="400x300"
							width={400}
							height={300}
							loading="eager"
						/>
					</div>
				</div>

				<div className={styles.bottomrow}>
					<SSRSuspense>
						<InlineFilters isMobile />
					</SSRSuspense>
				</div>
			</div>
		</div>
	);
};

export default IntroRehoming;
